import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBurgerClose = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12.3137 1L1.00001 12.3137",
		stroke: "white",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M1 1L12.3137 12.3137",
		stroke: "white",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})]
});
export default SvgBurgerClose;
